var _style, _rect, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _rect2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129 103",
    style: {
      enableBackground: "new 0 0 129 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#305E74;}\n\t.st1{opacity:0.21;fill:none;stroke:#DAC7B5;stroke-width:12;stroke-miterlimit:10;}\n\t.st2{fill:#65685D;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st3{fill:#DAC7B5;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -854,
    y: 1009,
    className: "st0",
    width: 1931,
    height: 1094
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2019.2,326.7 -1624.6,869.1 -1230,329.1 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2019.2,245.5 -1624.6,787.9 -1230,247.8 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2019.2,164.2 -1624.6,706.6 -1230,166.5 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2371,1602.6 -2765.6,1060.2 -3160.2,1600.3 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2371,1683.9 -2765.6,1141.5 -3160.2,1681.5 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-2371,1765.1 -2765.6,1222.7 -3160.2,1762.8 "
  })), /*#__PURE__*/React.createElement("rect", {
    x: -2386.9,
    y: -14.1,
    style: {
      fill: "none"
    },
    width: 175.9,
    height: 64
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2386.9473 5.8246)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st3",
    style: {
      fontFamily: "'Agenda-Regular'",
      fontSize: 28
    }
  }, "MADELINE "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33.6,
    className: "st3",
    style: {
      fontFamily: "'Agenda-Regular'",
      fontSize: 28
    }
  }, "ARMSTRONG")), /*#__PURE__*/React.createElement("g", {
    id: "idy7oA_00000079460591526701161720000016733231367080716470_"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1024,
    height: 323,
    id: "idy7oA_00000163030755850157433290000004562159405953297327_",
    xlinkHref: "94CBAC298F72EF34.jpg",
    transform: "matrix(2.7954 0 0 3 -2411.4912 778.0125)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -918,
    y: -39,
    className: "st2",
    width: 387,
    height: 284
  })), /*#__PURE__*/React.createElement("rect", {
    x: 522.6,
    y: 1223.5,
    style: {
      fill: "none"
    },
    width: 434.5,
    height: 352.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 522.5791 1272.4453)",
    style: {
      fill: "#ADC161",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 69
    }
  }, "hey there"), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "122.3,51.9 79.4,103 54.5,103 97.5,51.9 53.9,0 78.7,0  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "78,51.9 35,103 10.2,103 53.2,51.9 9.6,0 34.4,0  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullets);
export default __webpack_public_path__ + "static/media/bullets.53992e15449b6e44b31918d5c7843947.svg";
export { ForwardRef as ReactComponent };